import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  workingTime: null,
  loading: false,
  editLoading: false,
  editSuccess: false,
  editFail: false,
  wizardLoading: false,
  wizardSuccess: false,
  wizardFail: false,
  removeLoading: false,
  removeSuccess: false,
  removeFail: false,
};

const WorkingTimeSlice = createSlice({
  name: "workingTime",
  initialState,
  reducers: {
    fetch: (state) => ({
      ...state,
      loading: true,
      workingTime: null,
    }),
    fetch_SUCCESS: (state, { payload }) => ({
      ...state,
      loading: false,
      workingTime: payload.data.workingTime,
    }),
    fetch_FAIL: (state) => ({
      ...state,
      loading: false,
      workingTime: null,
    }),
    wizard: (state) => ({
      ...state,
      wizardLoading: true,
      wizardSuccess: false,
      wizardFail: false,
    }),
    wizard_SUCCESS: (state) => ({
      ...state,
      wizardLoading: false,
      wizardSuccess: true,
      wizardFail: false,
    }),
    wizard_FAIL: (state) => ({
      ...state,
      wizardLoading: false,
      wizardSuccess: false,
      wizardFail: true,
    }),
    edit: (state) => ({
      ...state,
      editLoading: true,
      editSuccess: false,
      editFail: false,
    }),
    edit_SUCCESS: (state) => ({
      ...state,
      editLoading: false,
      editSuccess: true,
      editFail: false,
    }),
    edit_FAIL: (state) => ({
      ...state,
      editLoading: false,
      editSuccess: false,
      editFail: true,
    }),
    remove: (state) => ({
      ...state,
      removeLoading: false,
      removeSuccess: false,
      removeFail: false,
    }),
    remove_SUCCESS: (state) => ({
      ...state,
      removeLoading: false,
      removeSuccess: true,
      removeFail: false,
    }),
    remove_FAIL: (state) => ({
      ...state,
      removeLoading: false,
      removeSuccess: false,
      removeFail: true,
    }),
    reset: (state) => ({
      ...state,
      ...initialState,
    }),
  },
});

export const { reset } = WorkingTimeSlice.actions;

export default WorkingTimeSlice.reducer;

export const fetch = (ulid) => ({
  type: "workingTime/fetch",
  payload: {
    client: "default",
    request: {
      url: `portal/working-time/details/${ulid}`,
    },
  },
});

export const wizard = (data) => ({
  type: "workingTime/wizard",
  payload: {
    client: "default",
    request: {
      method: "post",
      data,
      url: "portal/working-time/wizard",
    },
  },
});

export const edit = (ulid, data, editSet = false) => ({
  type: "workingTime/edit",
  payload: {
    client: "default",
    request: {
      method: "post",
      data: {
        ...data,
        editSet,
      },
      url: `portal/working-time/edit/${ulid}`,
    },
  },
});

export const remove = (ulid, removeSet = false) => ({
  type: "workingTime/remove",
  payload: {
    client: "default",
    request: {
      method: "delete",
      data: {
        removeSet,
      },
      url: `portal/working-time/remove/${ulid}`,
    },
  },
});
